// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1B1Sm","header":"Messages_header__A-0oS"};